import React from 'react'

import NotFound from '../../../components/NotFound'
import { fetchProjectData } from '../../../data/server/query-transform/fetchProjectData'
import Project from '../../projects/[slug].page'

const ProjectsPreview = ({ data, err }) => {
  if (err || !data?.[0]?.fields) {
    return <NotFound />
  }

  return <Project data={data} />
}

export async function getServerSideProps(context) {
  return await fetchProjectData({ slug: context?.params?.slug, isPreview: true })
}

export default ProjectsPreview
